// extracted by mini-css-extract-plugin
export default {"root":"Orders-root-f64a","filters":"Orders-filters-bb32","select":"Orders-select-e922"};